export const findAndInsert = <T extends Record<string, any>>(
  arr: T[],
  findObject: T,
  insertObject: T,
  field: keyof T
): T[] => {
  const newArray: T[] = [];

  for (let i = 0; i < arr.length; i++) {
    const currentObject = arr[i];

    newArray.push(currentObject);

    if (currentObject[field] === findObject[field]) {
      newArray.push(insertObject);
    }
  }

  return newArray;
};
